import axios from '@/axios.js';

export const widgetApi = {
  getWidgets(payload) {
    return axios.get(`admin/widgets?sort=sequence,ASC&sort=updatedAt,DESC`, {
      params: payload,
    });
  },
  addWidget(body) {
    return axios.post(`admin/widgets`, body);
  },
  getWidget(id) {
    return axios.get(`admin/widgets/${id}?join=belongsTo&join=translations`);
  },
  updateWidget(id, body) {
    return axios.patch(`admin/widgets/${id}`, body);
  },
  deleteWidget(id) {
    return axios.delete(`admin/widgets/${id}`);
  },
  updateSequence(body) {
    return axios.patch(`admin/widgets/sequence`, body);
  },
};
